import http from '../../api/api';
import axios from '../../api/api';

const getLearnerLanguage = () => localStorage.getItem('i18nextLng') || 'en-US';

export const getCertBasedOnLearnerId = (
  learnerID,
  upcoming,
  pageNum,
  ongoing
) => {
  let query = {};
  if (upcoming) query = { ...query, upcoming };
  if (ongoing) query = { ...query, ongoing };
  if (pageNum) query = { ...query, pageNum };

  return http.get(`/api/app/certs/list/${learnerID}`, { params: query });
};

export const startCertExam = (obj) =>
  http.post('/api/app/certs/start-cert', obj);

export const resumeCertExam = (obj) =>
  http.post(`/api/app/certs/resume-cert?lang=${getLearnerLanguage()}`, obj);

export const getCertExamQuestions = (certId) =>
  http.post(`/api/app/certs/questions-from-cert?lang=${getLearnerLanguage()}`, { certId });

export const submitCertExamAns = (payload) =>
  http.post(`/api/app/certs/submit-answer?lang=${getLearnerLanguage()}`, payload);

export const fetchCertById = (learnerId, certId) =>
  http.post('/api/app/certs/get-cert-by-id', { certId, learnerId });

export const finishCertTest = (payload) =>
  http.post('/api/app/certs/finish-cert-test', payload);

export const fetchCertReport = (resultId) =>
  http.post('/api/app/certs/get-cert-report', { resultId });
